import React from "react";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";

//Botón flotante de ayuda: muestra los datos de contacto del municipio
//para los vecinos que tengan problemas para emitir su voto.
const BotonAyuda = (props) => {
  const { municipio } = props;

  //El campo web puede venir sin protocolo (ej: www.municipio.gob.ar).
  const urlWeb =
    municipio.web && !municipio.web.startsWith("http")
      ? `https://${municipio.web}`
      : municipio.web;

  const mostrarAyuda = () => {
    Swal.fire({
      title: "¿Necesitás ayuda?",
      html:
        `<p>Si tenés problemas para emitir tu voto, comunicate con el municipio y te vamos a ayudar:</p>` +
        (municipio.tel
          ? `<p class="mb-1"><b>Teléfono:</b> <a href="tel:${String(
              municipio.tel
            ).replace(/[^\d+]/g, "")}">${municipio.tel}</a></p>`
          : "") +
        (municipio.email
          ? `<p class="mb-1"><b>Email:</b> <a href="mailto:${municipio.email}">${municipio.email}</a></p>`
          : "") +
        (municipio.web
          ? `<p class="mb-0"><b>Web:</b> <a href="${urlWeb}" target="_blank" rel="noopener noreferrer">${municipio.web}</a></p>`
          : ""),
      icon: "info",
      confirmButtonText: "Entendido",
    });
  };

  return (
    <button
      type="button"
      className="btn-ayuda"
      onClick={mostrarAyuda}
      aria-label="Ayuda para votar"
    >
      <FontAwesomeIcon icon={faQuestionCircle} /> Ayuda
    </button>
  );
};

export default BotonAyuda;
